import Conversations from './Conversations';

export default Conversations;


// WEBPACK FOOTER //
// ./src/pages/chat/conversations/index.js